import { createFileRoute } from "@tanstack/react-router";
import CopywritingStyle from "./-copywritingStyle";

export const Route = createFileRoute("/_layout/system/copywritingStyle")({
  staticData: {
    menuLabel: "文案风格配置",
    showInMenu: true,
    menuGroup: "/system",
    menuOrder: 3,
  },
  component: CopywritingStyle,
});
